import {Box, Divider, Drawer, useMediaQuery, useTheme} from "@mui/material";
import React, {useEffect} from "react";
import {Link} from "react-router-dom";
import styled from "styled-components";
import {TgIcon} from "./svgr/tg-icon";
import {MailIcon} from "./svgr/mail-icon";
import {SUPPORT_MAILTO, SUPPORT_TELEGRAM} from "@shared/config/env";

export const BurgerMenu: React.FC = () => {
    const [isOpen, setIsOpen] = React.useState(false);

    const theme = useTheme()

    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    useEffect(() => {
        if (!isMobile) {
            setIsOpen(false)
        }
    }, [isMobile])

    const onCloseMenu = () => {
        setIsOpen(false)
    }

    return (
        <>
            <Wrapper>
                <svg onClick={() => setIsOpen(!isOpen)} className="w-5 h-5" aria-hidden="true"
                     xmlns="http://www.w3.org/2000/svg" fill="none"
                     viewBox="0 0 17 14">
                    {isOpen ? (
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                              d="M1 1l6 6 6-6M1 13l6-6 6 6"/>
                    ) : (
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                              d="M1 1h15M1 7h15M1 13h15"/>
                    )}
                </svg>
            </Wrapper>
            <Drawer
                anchor="right"
                PaperProps={{
                    sx: {
                        background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.30) 0%, rgba(0, 0, 0, 0.30) 100%), rgba(240, 238, 233, 0.30)',
                        backgroundBlendMode: 'normal, screen',
                        backdropFilter: 'blur(5px)'
                    }
                }}
                onClose={onCloseMenu}
                open={isOpen}>
                <Box sx={{
                    width: '237px',
                    height: '100%',
                    padding: '25px 12px 16px',
                    display: 'flex',
                    flexDirection: 'column',
                }}>
                    <Logo width={81} height={20} src="/logo.png" alt="Plumme Logo" style={{marginBottom: '43px'}}/>
                    <Menu>
                        <ExternalLink href={SUPPORT_MAILTO}>
                            Сотрудничество
                        </ExternalLink>

                        <ExternalLink href={SUPPORT_MAILTO} target="_blank" rel="noopener noreferrer">
                            Поддержка
                        </ExternalLink>

                        <MenuLink to="/about">
                            О нас
                        </MenuLink>
                    </Menu>
                    <FooterWrapper>
                        <Icons>
                            {/*<IconLink href={SUPPORT_TELEGRAM} target="_blank" rel="noopener noreferrer">*/}
                            {/*    <TgIcon/>*/}
                            {/*</IconLink>*/}
                            <IconLink href={SUPPORT_MAILTO}>
                                <MailIcon/>
                            </IconLink>
                        </Icons>
                        <Divider sx={{borderColor: '#fff', paddingTop: '20px'}}/>
                        <LinksWrapper>
                            <FooterLink to="/user-agreement">
                                Пользовательское соглашение
                            </FooterLink>
                            <FooterLink to="/privacy-policy">
                                Политика конфиденциальности
                            </FooterLink>
                            {/*<FooterLink to="/user-agreement">*/}
                            {/*    Согласие на получение рассылок*/}
                            {/*</FooterLink>*/}
                            <FooterLink to="/community-guide">
                                Правила пространства
                            </FooterLink>
                        </LinksWrapper>
                        <Label>
                            © 2026 Plumme
                        </Label>
                    </FooterWrapper>
                </Box>
            </Drawer>
        </>
    );
};

const Wrapper = styled.button`
    display: block;
    z-index: 1301; /* Выше чем Drawer (1300) */
    position: fixed; /* Фиксируем позицию */
    top: 28px;
    right: 25px;
    @media (min-width: 900px) {
        display: none;
    }
`;

const Menu = styled.nav`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 43px;
    flex: 1;
`

const MenuLink = styled(Link)`
    color: #feffff;
    font-size: 18px;
    text-decoration: none;

    &:hover {
        color: #E46DD6;
    }
`

const ExternalLink = styled.a`
    color: #feffff;
    font-size: 18px;
    text-decoration: none;

    &:hover {
        color: #E46DD6;
    }
`

const Logo = styled.img`
    height: 20px;
`;

const FooterWrapper = styled.div`
    color: #feffff;
    padding: 0 4px;
`

const Icons = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
`

const LinksWrapper = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin-top: 16px;
    gap: 16px;
`

const FooterLink = styled(Link)`
    color: #FFF;
    text-align: center;
    font-feature-settings: 'liga' off, 'clig' off;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    text-decoration: none;

    &:hover {
        color: #E46DD6;
    }
`

const Label = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 16px;
    color: #FFF;
    text-align: center;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Manrope;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
`

const IconLink = styled.a`
    color: #FFF;
    text-decoration: none;

    &:hover {
        opacity: 0.8;
    }
`